export default __webpack_public_path__ + "static/media/my_logo.d7c5db8b.jpg";